import { Link } from 'react-router-dom';

// @mui material components
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

// Material Dashboard components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

// Authentication layout components
import BasicLayout from 'composites/BasicLayout';

// Image
import bgImage from 'assets/images/bg-sign-in-basic.jpeg';

function AuthRequired(): JSX.Element {
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="error"
          borderRadius="lg"
          coloredShadow="error"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Authentication Required
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3} textAlign="center">
          <MDTypography variant="body1" mb={3}>
            You need to sign in to access this page.
          </MDTypography>
          <Grid container justifyContent="center">
            <Grid item>
              <MDButton
                component={Link}
                to="/sign-in"
                variant="gradient"
                color="info"
              >
                Sign In
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default AuthRequired;
